import React from 'react';
import { modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-194" data-mp="100c9f2m1l0zr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-195" data-mp="zy97plbj1jf7">
        <header className="mx-auto max-w-4xl text-center" data-id="element-196" data-mp="l4mrpgnw3a0u">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-197" data-mp="q264ec4xveqo">
            Sistema Completo:
            <br data-id="element-198" data-mp="1dtbjuq6yw50g" />
            <span className="text-blue-600" data-id="element-199" data-mp="1dssdm6qoj529">50 Mapas Visuales</span>
          </h2>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-200" data-mp="1iqbqp3bn5bsm">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-201" data-mp="140cx7dv16ojh">
              <div className="flex items-baseline gap-3" data-id="element-202" data-mp="1wq33x1uc2o5k">
                <span className="text-5xl font-extrabold leading-none tracking-tight text-teal-900" data-id="element-203" data-mp="21hbei17egfkb">
                  {module.count}
                </span>
                <span className="text-sm font-extrabold uppercase tracking-[0.12em] text-teal-900/80" data-id="element-204" data-mp="2vg3nllo8uyll">
                  mapas
                </span>
              </div>
              <h3 className="mt-4 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-205" data-mp="356ot7t2c53e0">
                {module.title}
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-206" data-mp="30cu42a3ynw7j">{module.summary}</p>
              <p className="mt-auto pt-4 font-semibold text-blue-700" data-id="element-207" data-mp="3e50h3nbthn2r">{module.closing}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}